// ── Module ────────────────────────────────────────────────────────────
export { AumicoAiAgentsModule } from './aumico-ai-agents.module';

// ── Config ────────────────────────────────────────────────────────────
export { AumicoAiAgentsConfig, AUMICO_AI_AGENTS_CONFIG } from './aumico-ai-agents.config';

// ── Interfaces ────────────────────────────────────────────────────────
export { AiAgentJobRequest } from './interfaces/ai-agent-job-request.interface';
export {
    AiAgentSession,
    AiTrajectoryEntry,
    AiChatMessage,
} from './interfaces/ai-agent-session.interface';
export {
    AiJobProgressEvent,
    AiJobCompletedEvent,
} from './interfaces/ai-agent-progress-event.interface';
export { AiAgentStatus } from './interfaces/ai-agent-status.enum';
export {
    AiAbcpRunStatus,
    AiAbcpRunSummary,
    AiAbcpTrailEntryKind,
    AiAbcpTrailEntry,
    AiAbcpTrailPage,
} from './interfaces/ai-abcp-run-trail.interface';

// ── HTTP client ───────────────────────────────────────────────────────
export { AiAgentHttpService } from './services/ai-agent-http.service';

// ── Provider ──────────────────────────────────────────────────────────
export { IAiAgentProvider } from './provider/ai-agent.provider.interface';
export { AiAgentProvider } from './provider/ai-agent.provider';

// ── Org Settings Service ──────────────────────────────────────────────
export { AiOrgSettingsService } from './services/ai-org-settings.service';
export {
    OrgAiSettings,
    AiAgentSettingEntry,
    AiServiceEntry,
    ServiceConsent,
    MasterAgb,
    SetAiFeaturesRequest,
    LocalizedString,
    SupportedLang,
    masterCovers,
    pickLang,
} from './interfaces/ai-org-settings.interface';

// ── Components ────────────────────────────────────────────────────────
export { AiFixerPanelComponent } from './components/ai-fixer-panel/ai-fixer-panel.component';
export { AiFixerProgressComponent } from './components/ai-fixer-progress/ai-fixer-progress.component';

// ── NgRx (selective) ──────────────────────────────────────────────────
import * as AiAgentActions from './actions/ai-agent.actions';
export { AiAgentActions };
export {
    selectActiveSessionId,
    selectSession,
    selectStatus,
    selectProgressEvents,
    selectOutput,
    selectIsSubmitting,
    selectError,
    selectSocketConnected,
    selectChatHistory,
} from './reducer/ai-agent.reducer';
